import { render, staticRenderFns } from "./response_contact.html?vue&type=template&id=4d90b70f&scoped=true&"
import script from "./response_contact.js?vue&type=script&lang=js&"
export * from "./response_contact.js?vue&type=script&lang=js&"
import style0 from "./response_contact.scss?vue&type=style&index=0&id=4d90b70f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90b70f",
  null
  
)

export default component.exports